import { render, staticRenderFns } from "./ListItem.vue?vue&type=template&id=6fd7ff8f&scoped=true"
var script = {}
import style0 from "./ListItem.vue?vue&type=style&index=0&id=6fd7ff8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd7ff8f",
  null
  
)

export default component.exports